<template>
  <div>
    修改密码
  </div>
</template>

<script>
	export default {
		name: 'Password',
	}
</script>


// WEBPACK FOOTER //
// src/components/Password.vue